import { Controller } from "@hotwired/stimulus"

export function typingIn(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement | null
  if (event.metaKey || event.ctrlKey || event.altKey) return true
  if (target === null) return false
  if (target.isContentEditable) return true
  if (target instanceof HTMLInputElement) return target.type !== "checkbox"
  return target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement
}

export default class extends Controller<HTMLElement> {
  press(event: KeyboardEvent): void {
    if (typingIn(event)) return

    const element = this.element.querySelector<HTMLElement>(`[data-hotkey~="${CSS.escape(event.key)}"]`)
    if (element === null) return

    event.preventDefault()
    if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
      element.focus()
    } else {
      element.click()
    }
  }
}
